import "./InputField.css";

export default function InputField({ label, name, value, type, placeholder, onChange }) {
  return (
    <div className="input-field">
        <label for="email" className="input-label">{label}</label>
        <input
            className="user-input"
            name={name}
            value={value}
            type={type}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
        />
    </div>
  );
}